import styled from 'styled-components';
import { token } from '@zillow/constellation';
import { ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX } from '../../ZillowNavbarHeader';

export const MobileDropdownMenuContainer = styled.div`
    position: fixed;
    top: ${ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX.MOBILE + 1}px;
    left: 0;
    overflow: scroll;
    width: 100vw;
    height: calc(100vh - ${ZILLOW_NAVBAR_HEADER_HEIGHT_IN_PX.MOBILE + 1}px);
    box-sizing: border-box;
    z-index: 1000;
    background-color: ${token('colors.backgroundWhite')};
`;
